export default __webpack_public_path__ + "static/media/04_Business-PortraitArchitecture-InteriorEschweilerPhotography_M1A6886.6cdf2c8f.jpg";